import './Content.scss'
import Section from './section/Section';
import { SectionData } from './section';


export default (props: { scrolledPage: boolean }) => {
    const sections: SectionData[] = [
        {
            key: '1',
            title: 'About',
            content: '<div class="about-content">Solopreneur with more than 10 years of experience in the tech industry.<br/> Providing high quality software solutions and consulting. <br/> Drop an <b>email</b> if you are interested.</div>',
            tags: [],
            scrolledPage: props.scrolledPage
        },
        {
            key: '2',
            title: 'Services',
            tags: ['Software solutions', 'Mobile Products', 'Consulting'],
            content: '',
            scrolledPage: props.scrolledPage
        },
        {
            key: '3',
            title: 'Projects',
            tags: [],
            content: '<div class="projects-content"><a href="https://rankomix.dev-set.com" target="_blank">Rankomix</a> - ranking deposits and savings account<br/><a href="https://renty.dev-set.com" target="_blank">Renty</a> - tinder for renting properties<br/><a href="https://charger.dev-set.com" target="_blank">Charger Rent</a> - renting Dodge Charger</div>',
            scrolledPage: props.scrolledPage
        }
    ];


    return (
        <main className='page-content parallax-background'>
            {
                sections.map((section, i) => (
                    <div key={section.key}>
                        <Section {...section} />
                        <div className='space'></div>
                    </div>

                ))
            }
        </main>
    )
}